import { useState } from "react";
import {
  Container,
  Stack,
  Typography,
  Box,
  Modal,
  IconButton,
} from "@mui/material";
import Hotel from "./Hotel";
import CloseIcon from "@mui/icons-material/Close";
import HotelCard from "./HotelCard";
import imageIndex from "../ImageIndex";

const sampleHotels = [
  {
    id: "hotel-riu-plaza-guadalajara",
    name: "RIU PLAZA GUADALAJARA",
    location: "Guadalajara, Jalisco",
    logo: imageIndex.RIULogo,
  },
  {
    id: "hotel-holiday-inn-guadalajara-select",
    name: "HOLIDAY INN GUADALAJARA SELECT",
    location: "Guadalajara, Jalisco",
    logo: imageIndex.HolidayLogo,
  },
  {
    id: "hotel-holiday-inn-guadalajara-expo",
    name: "HOLIDAY INN GUADALAJARA EXPO",
    location: "Zapopan, Jalisco",
    logo: imageIndex.HolidayLogo,
  },
  {
    id: "hotel-wyndham-garden-guadalajara-expo",
    name: "WYNDHAM GARDEN GUADALAJARA EXPO",
    location: "Zapopan, Jalisco",
    logo: imageIndex.WyndhamLogo,
  },
  {
    id: "hotel-fiesta-americana",
    name: "FIESTA AMERICANA",
    location: "Guadalajara, Jalisco",
    logo: imageIndex.FiestaAmericanaLogo,
  },
  {
    id: "hotel-presidente-intercontinental-guadalajara",
    name: "PRESIDENTE INTERCONTINENTAL GUADALAJARA",
    location: "Zapopan, Jalisco",
    logo: imageIndex.PresidenteInterLogo,
  },
  {
    id: "hotel-meson-del-anima",
    name: "MESON DEL ÁNIMA",
    location: "Sayula, Jalisco",
    logo: imageIndex.MesonAnimaLogo,
  },
  {
    id: "hotel-la-casa-de-los-patios",
    name: "LA CASA DE LOS PATIOS",
    location: "Sayula, Jalisco",
    logo: imageIndex.LaCasaPatiosLogo,
  },
  {
    id: "hotelito-sayula",
    name: "HOTELITO SAYULA",
    location: "Sayula, Jalisco",
    logo: imageIndex.HotelitoSayulaLogo,
  },
];

const detailedHotels = [
  {
    name: "HOTEL RIU PLAZA GUADALAJARA",
    logo: imageIndex.RIULogo,
    dates: "17 AL 22 NOVIEMBRE 2025",
    location: {
      address: "Av. Adolfo López Mateos Sur 830, Chapalita",
      city: "Guadalajara",
      state: "Jalisco",
      zipCode: "44500",
    },
    contact: {
      phone: "33 3880 7500",
      email: "customerservices.zgd@riu.com",
    },

    rooms: [
      {
        name: "DELUXE SENCILLA / DOBLE",
        price: 2490,
      },
      {
        name: "EJECUTIVA SENCILLA / DOBLE",
        price: 2990,
      },
      {
        name: "JUNIOR SUITE",
        price: 3440,
      },
    ],
    amenities: ["DESAYUNO BUFFET", "WIFI", "PISCINA", "GIMNASIO"],
    image: imageIndex.RiuInfo,
    reservationCode: "ENMICE",
    reservationUrl: "https://www.riu.com/es/posts/codigo-corporativo.jsp",
  },
  {
    name: "HOTEL HOLIDAY INN GUADALAJARA SELECT",
    logo: imageIndex.HolidayLogo,
    dates: "17 AL 21 NOVIEMBRE 2025",
    location: {
      address: " Av Niños Héroes 3089, Jardines del Bosque",
      city: "Guadalajara",
      state: "Jalisco",
      zipCode: "44500",
    },
    contact: {
      phone: "33 3122 2020",
      email: "reservaciones@hisguadalajara.com.mx",
    },
    rooms: [
      {
        name: "HABITACIÓN",
        price: 1712,
      },
    ],
    amenities: ["HOSPEDAJE", "DESAYUNO BUFFET", "WIFI"],
    reservationCode: "EC1",
    image: imageIndex.HolidayInnInfo,
    reservationUrl: "https://hisguadalajara.com.mx/",
  },
  {
    name: "HOTEL HOLIDAY INN GUADALAJARA EXPO",
    logo: imageIndex.HolidayLogo,
    dates: "17 AL 21 NOVIEMBRE 2025",
    location: {
      address: "Av. Adolfo López Mateos Sur 2500, Cd del Sol",
      city: "Zapopan",
      state: "Jalisco",
      zipCode: "45050",
    },
    contact: {
      phone: "33 3634 1034",
      email: "reservaciones@higuadalajaraexpo.com.mx",
    },
    rooms: [
      {
        name: "HABITACIÓN",
        price: 1712,
      },
    ],
    amenities: ["HOSPEDAJE", "DESAYUNO BUFFET", "WIFI"],
    reservationCode: "EN1",
    image: imageIndex.HolidayInnInfo,
    reservationUrl: "https://higuadalajaraexpo.com.mx/",
  },
  {
    name: "HOTEL WYNDHAM GARDEN GUADALAJARA EXPO",
    logo: imageIndex.WyndhamLogo,
    dates: "17 AL 21 NOVIEMBRE 2025",
    location: {
      address:
        "Casi Esquina, Av Mariano Otero, Av. Adolfo López Mateos Sur 3875",
      city: "Zapopan",
      state: "Jalisco",
      zipCode: "45050",
    },
    contact: {
      phone: "33 3634 1000",
      email: "eservaciones@wgardengdlexpo.mx",
    },
    rooms: [
      {
        name: "HABITACIÓN",
        price: 1255,
      },
    ],
    amenities: ["HOSPEDAJE", "DESAYUNO BUFFET", "WIFI"],
    reservationCode: "11177021 A-001",
    image: imageIndex.HolidayInnInfo,
    reservationUrl: "https://wgardengdlexpo.mx/",
  },
  {
    name: "HOTEL FIESTA AMERICANA",
    logo: imageIndex.FiestaAmericanaLogo,
    dates: "17 AL 22 NOVIEMBRE 2025",
    location: {
      address: "Glorieta Minerva, C. Aurelio Aceves 225, Vallarta Poniente",
      city: "Guadalajara",
      state: "Jalisco",
      zipCode: "44110",
    },
    contact: {
      phone: "800 504 5000",
      email: "ventas1fagd@posadas.com",
    },
    rooms: [
      {
        name: "ESTÁNDAR SENCILLA / DOBLE",
        price: 2215,
      },
      {
        name: "EJECUTIVA SENCILLA / DOBLE",
        price: 2575,
      },
    ],
    amenities: ["HOSPEDAJE", "WIFI"],
    reservationCode: "G1TDQD@FAG",
    image: imageIndex.FiestaAmericanaInfo,
    reservationUrl:
      "https://www.fiestamericanatravelty.com/fiesta-americana/hoteles/fiesta-americana-guadalajara",
  },
  {
    name: "HOTEL PRESIDENTE INTERCONTINENTAL GUADALAJARA",
    logo: imageIndex.PresidenteInterLogo,
    dates: "17 AL 22 NOVIEMBRE 2025",
    location: {
      address: "Av. Lopez Mateos Y Moctezuma",
      city: "Zapopan",
      state: "Jalisco",
      zipCode: "45050",
    },
    contact: {
      phone: "33 3678 1234",
      email: "guadalajara@grupopresidente.com",
    },
    rooms: [
      {
        name: "HABITACIÓN ESTANDAR",
        price: 2398,
      },
      {
        name: "DESAYUNO BUFFET",
        price: 350,
      },
    ],
    amenities: ["HOSPEDAJE", "WIFI"],
    reservationCode: "ENMICE o EN3",
    image: imageIndex.PresidenteIntercontinentalInfo,
    reservationUrl: "https://presidenteicguadalajara.com/",
  },
  {
    name: "HOTEL MESON DEL ANIMA",
    logo: imageIndex.MesonAnimaLogo,
    dates: "18 AL 22 NOVIEMBRE 2025",
    location: {
      address: "Av. Manuel Avila Camacho 171 OTE",
      city: "Sayula",
      state: "Jalisco",
      zipCode: "49300",
    },
    contact: {
      phone: "34 2112 7773",
      email: "contacto@mesondelanima.com",
    },
    rooms: [
      {
        name: "BÁSICA CAMA MATRIMONIAL",
        price: 750,
      },
      {
        name: "ESTANDAR 2 CAMAS MATRIMONIALES",
        price: 900,
      },
      {
        name: "ESTANDAR CAMA KING SIZE",
        price: 950,
      },
      {
        name: "JUNIOR SUIT CAMA KING SIZE",
        price: 1300,
      },
      {
        name: "SUIT 2 CAMAS MATRIMONIALES",
        price: 1600,
      },
    ],
    amenities: ["HOSPEDAJE", "WIFI", "ALBERCA", "PET FRIENDLY"],
    image: imageIndex.MesonAnimaInfo,
    reservationUrl: "https://mesondelanima.com/",
  },
  {
    name: "HOTEL LA CASA DE LOS PATIOS",
    logo: imageIndex.LaCasaPatiosLogo,
    dates: "18 AL 22 NOVIEMBRE 2025",
    location: {
      address: "Vallarta 89 Centro",
      city: "Sayula",
      state: "Jalisco",
      zipCode: "49300",
    },
    contact: {
      phone: "34 2109 7143",
      email: "facturaspatios@outlook.es",
    },
    rooms: [
      {
        name: "LUNES A JUEVES (1 Persona)",
        price: 1300,
      },
      {
        name: "LUNES A JUEVES (2 a 4 Personas)",
        price: 1650,
      },
      {
        name: "VIERNES A DOMINGO (1 Persona)",
        price: 1750,
      },
      {
        name: "VIERNES A DOMINGO (2 a 4 Personas)",
        price: 2250,
      },
    ],
    amenities: ["HOSPEDAJE", "WIFI", "ALBERCA", "ESTACIONAMIENTO"],
    image: imageIndex.CasaDeLosPatiosInfo,
    reservationUrl: "https://lacasadelospatios.gabsuite.com/",
  },
  {
    name: "HOTELITO SAYULA",
    logo: imageIndex.HotelitoSayulaLogo,
    dates: "18 AL 22 NOVIEMBRE 2025",
    location: {
      address: "Av. Vallarta 257",
      city: "Sayula",
      state: "Jalisco",
      zipCode: "49300",
    },
    contact: {
      phone: "34 2422 3287",
      email: "hotelitosayula@hotmail.com",
    },
    rooms: [
      {
        name: "HABITACIÓN CAMA MATRIMONIAL",
        price: 700,
      },
      {
        name: "HABITACIÓN CAMA KING SIZE",
        price: 800,
      },
      {
        name: "HABITACIÓN DOBLE 2 MATRIMONIALES",
        price: 900,
      },
      {
        name: "HABITACIÓN DOBLE 2 INDIVIDUALES",
        price: 700,
      },
      {
        name: "HABITACIÓN DOBLE 1 INDIVIDUAL / 1 MATRIMONIAL",
        price: 800,
      },
      {
        name: "HABITACIÓN TRIPLE 1 INDIVIDUAL / 1 MATRIMONIAL / 1 KING SIZE",
        price: 1200,
      },
    ],
    amenities: ["HOSPEDAJE", "WIFI", "LIMPIEZA", "TV"],
    image: imageIndex.HotelitoSayulaInfo,
    reservationUrl: "https://www.facebook.com/hotelitosayula/?locale=es_LA",
  },
];

export default function Hospedajes() {
  const [selectedHotel, setSelectedHotel] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);

  const handleHotelClick = (hotelId) => {
    const hotel = detailedHotels.find((h) =>
      h.name.toLowerCase().includes(hotelId.replace(/-/g, " "))
    );
    setSelectedHotel(hotel);
    setModalOpen(true);
  };

  const handleCloseModal = () => {
    setModalOpen(false);
    setSelectedHotel(null);
  };

  return (
    <Box
      id="hero"
      sx={(theme) => ({
        width: "100%",
        backgroundRepeat: "no-repeat",
        backgroundImage:
          "radial-gradient(ellipse 80% 50% at 50% -20%, hsl(210, 100%, 90%), transparent)",
        ...theme.applyStyles("dark", {
          backgroundImage:
            "radial-gradient(ellipse 70% 110% at 50% -20%, hsl(210, 100%, 16%), transparent)",
        }),
        minHeight: "100vh",
      })}
    >
      <Container
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          pt: { xs: 14, sm: 20 },
          pb: { xs: 0, sm: 0 },
        }}
      >
        <Stack
          spacing={4}
          useFlexGap
          sx={{
            alignItems: "center",
            width: { xs: "100%", sm: "70%" },
            mb: 8,
            textAlign: "center",
          }}
        >
          <Typography
            variant="h1"
            sx={(theme) => ({
              display: "flex",
              flexDirection: { xs: "column", sm: "row" },
              alignItems: "center",
              fontSize: "clamp(3rem, 10vw, 3.5rem)",
              color: "primary.main",
              ...theme.applyStyles("dark", {
                color: "primary.light",
              }),
            })}
          >
            Hoteles y Hospedaje
          </Typography>

          <Typography
            variant="h5"
            component="p"
            sx={{
              color: "text.primary",
              maxWidth: 600,
              lineHeight: 1.6,
            }}
          >
            Descubre nuestras opciones de hospedaje con precios especiales,
            ubicaciones estratégicas y servicios de primera clase para tu
            estancia perfecta.
          </Typography>
        </Stack>

        <Box
          sx={{
            width: "100%",
            maxWidth: 1200,
            mt: 4,
            display: "grid",
            gridTemplateColumns: {
              xs: "1fr",
              sm: "repeat(2, 1fr)",
              md: "repeat(2, 1fr)",
            },
            gap: 4,
          }}
        >
          {sampleHotels.map((hotel) => (
            <Hotel
              key={hotel.id}
              id={hotel.id}
              name={hotel.name}
              location={hotel.location}
              logo={hotel.logo}
              onClick={() => handleHotelClick(hotel.id)}
            />
          ))}
        </Box>

        {/* Modal for showing detailed hotel information */}
        <Modal
          open={modalOpen}
          onClose={handleCloseModal}
          aria-labelledby="hotel-modal-title"
          aria-describedby="hotel-modal-description"
          disableEscapeKeyDown={true}
          sx={{
            display: "flex",
            alignItems: "flex-start", // Changed from 'center' to 'flex-start'
            justifyContent: "center",
            overflow: "auto",
            p: 0,
            "&::-webkit-scrollbar": {
              display: "none",
            },
            scrollbarWidth: "none",
          }}
        >
          <Box
            sx={{
              position: "relative",
              width: "100%",
              maxWidth: "896px",
              maxHeight: "90vh",
              overflow: "auto",
              bgcolor: "background.paper",
              borderRadius: 2,
              boxShadow: 24,
              p: 0,
              mt: 2,
              mb: 2,
              "&::-webkit-scrollbar": {
                display: "none",
              },
              scrollbarWidth: "none",
              msOverflowStyle: "none",
            }}
          >
            <IconButton
              aria-label="close"
              onClick={handleCloseModal}
              sx={{
                position: "sticky",
                top: 8,
                right: 8,
                float: "right",
                color: "text.primary",
                zIndex: 1,
                bgcolor: "background.paper",
                "&:hover": {
                  bgcolor: "grey.200",
                },
              }}
            >
              <CloseIcon />
            </IconButton>
            {selectedHotel && <HotelCard hotel={selectedHotel} />}
          </Box>
        </Modal>
      </Container>
    </Box>
  );
}
